import { z } from 'zod';
import { REQUIRED_ERROR, inputsLength, latinAlphanumericRegex } from '@/domains/auth/constants/validation';

export const validationSchema = z.object({
  username: z
    .string({ required_error: REQUIRED_ERROR })
    .min(inputsLength.username.min, {
      message: REQUIRED_ERROR,
    })
    .max(inputsLength.username.max)
    .regex(latinAlphanumericRegex),
});
